import React, { useState } from 'react';

/**
 * CopyableText — hiển thị một đoạn text kèm nút icon sao chép.
 *
 * Dùng chung cho cả trang DAT V1 và V2 (cột "Mã học viên" / "Tên học viên"
 * trong AG Grid, hoặc hiển thị inline trong modal). Tự chứa — không phụ
 * thuộc react-bootstrap hay react-toastify để dùng được ở mọi trang.
 *
 * Dùng làm AG Grid cellRenderer:
 *   cellRenderer: (p) => <CopyableText value={p.value} />
 *
 * Hoặc inline:
 *   <CopyableText value={student.name} />
 *
 * Props:
 *   value / text : giá trị hiển thị + sao chép (value ưu tiên text nếu cả hai).
 *   title        : tooltip nút sao chép.
 *   className    : class cho wrapper.
 */
const CopyIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    fill='currentColor'
    viewBox='0 0 16 16'
    aria-hidden='true'
  >
    <path fillRule='evenodd' d='M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z' />
  </svg>
);

export default function CopyableText({ value, text, title = 'Sao chép', className }) {
  const content = text != null ? text : value;
  const [copied, setCopied] = useState(false);

  if (content === null || content === undefined || content === '') return null;

  const handleCopy = (e) => {
    e.stopPropagation();
    const write = navigator.clipboard?.writeText
      ? navigator.clipboard.writeText(String(content))
      : Promise.reject(new Error('clipboard unavailable'));
    write
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => { /* im lặng — không chặn UI nếu clipboard bị chặn */ });
  };

  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, maxWidth: '100%' }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {content}
      </span>
      <button
        type='button'
        onClick={handleCopy}
        title={title}
        style={{
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          padding: 0,
          lineHeight: 1,
          flex: '0 0 auto',
          color: copied ? '#198754' : '#6c757d',
        }}
      >
        {copied ? '✓' : <CopyIcon />}
      </button>
    </span>
  );
}
